/* eslint-disable array-bracket-newline */
import { Fragment, useState } from 'react';
import Text from '../../atoms/Text';
import { IFaq } from './HelpBody';

interface IHelpSidebarProps {
  data: IFaq;
  setContent(text: string): void;
}

const HelpSidebar = ({ data, setContent }: IHelpSidebarProps) => {
  const [extendedIds, setExtendedIds] = useState<string[]>([data[0].name]);

  const toggleExtend = (id: string) => {
    if (extendedIds.includes(id)) {
      const updated = extendedIds.filter((item) => item !== id);
      return setExtendedIds(updated);
    }

    const updated = [...extendedIds, id];
    setExtendedIds(updated);
  };

  return (
    <div className='help__sidebar'>
      <Text size={14} className='help__sidebar__header'>
        Help
      </Text>
      <div className='help__sidebar__body'>
        {data.map((highLvl) => (
          <Fragment key={highLvl.name}>
            <div
              className='help__sidebar__body__first_lvl'
              onClick={() => toggleExtend(highLvl.name)}
            >
              <Text size={12}>{highLvl.name}</Text>
              <div
                className={`help__sidebar__body__first_lvl__extend icon-chevron-down ${
                  extendedIds.includes(highLvl.name)
                    ? 'help__sidebar__body__first_lvl__extend--active'
                    : ''
                }`}
              />
            </div>
            {extendedIds.includes(highLvl.name) &&
              highLvl.sub_items.map((lowLvl) => (
                <div
                  key={lowLvl.name}
                  className='help__sidebar__body__second_lvl'
                  onClick={() => setContent(lowLvl.text)}
                >
                  <Text size={12}>{lowLvl.name}</Text>
                </div>
              ))}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default HelpSidebar;
